import DOMPurify from 'dompurify'

/**
 * GP Connect returns each record as a rendered HTML view, so there is no
 * structured payload to build the UI from — the markup has to be injected. It
 * comes from a third party, so it goes through DOMPurify first.
 *
 * Deliberately uses DOMPurify's defaults: they strip scripts, event handlers
 * and javascript: URLs while leaving the presentational markup the records rely
 * on (tables, headings, lists, anchors, inline style, colspan/rowspan) intact.
 * Narrowing the allow-list would silently drop parts of a clinical record.
 */
export const sanitiseGpHtml = (html: string | undefined): string =>
  DOMPurify.sanitize(html || '')
